/************************************************************************
 ** IBM Confidential
 **
 ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
 **
 ** (C) Copyright IBM Corp. 2020
 **
 ** The source code for this program is not published or otherwise divested of its trade secrets, 
 ** irrespective of what has been deposited with the U.S. Copyright Office.
 ************************************************************************/
// GENERATED
import ObjectType from './ObjectType';
import MoserObject from './MoserObject';
import MoserObjectUtils from './MoserObjectUtils';
//@import com/ibm/bi/platform/moser/common/generated/metadata/ObjectType (loadtime) // superclass
//@import com/ibm/bi/platform/moser/common/generated/metadata/MoserObject (static) // fromJSONHelper
//@import com/ibm/bi/platform/moser/common/utils/MoserObjectUtils (runtime) // propertyOverrideForLocalRef

/**
 * <p>Java class for anonymous complex type. <p>The following schema fragment specifies the expected content contained within this class. <pre> &lt;complexType&gt; &lt;complexContent&gt; &lt;extension base="{}objectType"&gt; &lt;sequence&gt; &lt;element name="ref" type="{http://www.w3.org/2001/XMLSchema}string" maxOccurs="unbounded" minOccurs="0"/&gt; &lt;element name="calculatedMember" type="{}calculatedMemberType" maxOccurs="unbounded" minOccurs="0"/&gt; &lt;element name="localRef" type="{}localRefType" maxOccurs="unbounded" minOccurs="0"/&gt; &lt;/sequence&gt; &lt;/extension&gt; &lt;/complexContent&gt; &lt;/complexType&gt; </pre>
 */
export default class ItemHierarchy extends ObjectType{

	ref = null;

	calculatedMember = null;

	localRef = null;



	/**
	 * Gets the value of the ref property. <p> This accessor method returns a reference to the live list, not a snapshot. Therefore any modification you make to the returned list will be present inside the JAXB object. This is why there is not a <CODE>set</CODE> method for the ref property. <p> For example, to add a new item, do as follows: <pre> getRef().add(newItem); </pre> <p> Objects of the following type(s) are allowed in the list {@link String}
	 */
	getRef() {
		if (!this.ref) {
			this.ref = [];
		}
		return this.ref;
	}

	/**
	 * Gets the value of the calculatedMember property. <p> This accessor method returns a reference to the live list, not a snapshot. Therefore any modification you make to the returned list will be present inside the JAXB object. This is why there is not a <CODE>set</CODE> method for the calculatedMember property. <p> For example, to add a new item, do as follows: <pre> getCalculatedMember().add(newItem); </pre> <p> Objects of the following type(s) are allowed in the list {@link CalculatedMemberType}
	 */
	getCalculatedMember() {
		if (!this.calculatedMember) {
			this.calculatedMember = [];
		}
		return this.calculatedMember;
	}

	/**
	 * Gets the value of the localRef property. <p> This accessor method returns a reference to the live list, not a snapshot. Therefore any modification you make to the returned list will be present inside the JAXB object. This is why there is not a <CODE>set</CODE> method for the localRef property. <p> For example, to add a new item, do as follows: <pre> getLocalRef().add(newItem); </pre> <p> Objects of the following type(s) are allowed in the list {@link LocalRefType}
	 */
	getLocalRef() {
		if (!this.localRef) {
			this.localRef = [];
		}
		return this.localRef;
	}

	/**
	 * Gets the value of the <code>ref</code> property without initializing the property to an empty list if it is unset.
	 * @return {Array} the list of <code>String</code> elements, or <code>null</code> if not set
	 */
	basicGetRef() {
		return this.ref;
	}

	/**
	 * Gets the value of the <code>calculatedMember</code> property without initializing the property to an empty list if it is unset.
	 * @return {Array} the list of <code>CalculatedMemberType</code> elements, or <code>null</code> if not set
	 */
	basicGetCalculatedMember() {
		return this.calculatedMember;
	}

	/**
	 * Gets the value of the <code>localRef</code> property without initializing the property to an empty list if it is unset.
	 * @return {Array} the list of <code>LocalRefType</code> elements, or <code>null</code> if not set
	 */
	basicGetLocalRef() {
		return this.localRef;
	}

	/**
	 * Creates a new instance of <code>ItemHierarchy</code> object from JSON data.
	 * @param {ObjectFactory} factory <code>ObjectFactory</> object for object creation.
	 * @param {Object} json JSON data to be used to create the <code> ItemHierarchy</code> object from.
	 * @return {ItemHierarchy} an object of type <code>ItemHierarchy</code>
	 */
	static fromJSON(json, factory) {
		var result = factory.createItemHierarchy();
		var featureList = result.getFeatureList(factory);
		MoserObject.fromJSONHelper(result, featureList, json, factory);
		return result;
	}

	/**
	 * Adds the <code>item</code> to the collection at the given position and fires a notification to listeners.
	 */
	addRefAt(position, item) {
		this._addAtAndNotify(this.getRef(), position, item, 36, false, false);
	}

	/**
	 * Adds the <code>item</code> to the end of the collection and fires a notification to listeners.
	 */
	addRef(item) {
		this.addRefAt(this.getRef().length, item);
	}

	/**
	 * Removes the item at <code>position</code> from the collection and fires a notification to listeners.
	 */
	removeRefAt(position) {
		this._removeAtAndNotify(this.getRef(), position, 36, false);
	}

	/**
	 * Removes the <code>item</code> from the collection and fires a notification to listeners.
	 */
	removeRef(item) {
		var i = this.getRef().indexOf(item);
		if (i >= 0) {
			this.removeRefAt(i);
		}
	}

	/**
	 * Adds the <code>item</code> to the collection at the given position and fires a notification to listeners.
	 */
	addCalculatedMemberAt(position, item) {
		this._addAtAndNotify(this.getCalculatedMember(), position, item, 72, true, true);
	}

	/**
	 * Adds the <code>item</code> to the end of the collection and fires a notification to listeners.
	 */
	addCalculatedMember(item) {
		this.addCalculatedMemberAt(this.getCalculatedMember().length, item);
	}

	/**
	 * Removes the item at <code>position</code> from the collection and fires a notification to listeners.
	 */
	removeCalculatedMemberAt(position) {
		this._removeAtAndNotify(this.getCalculatedMember(), position, 72, true);
	}

	/**
	 * Removes the <code>item</code> from the collection and fires a notification to listeners.
	 */
	removeCalculatedMember(item) {
		var i = this.getCalculatedMember().indexOf(item);
		if (i >= 0) {
			this.removeCalculatedMemberAt(i);
		}
	}

	/**
	 * Adds the <code>item</code> to the collection at the given position and fires a notification to listeners.
	 */
	addLocalRefAt(position, item) {
		this._addAtAndNotify(this.getLocalRef(), position, item, 73, true, false);
		MoserObjectUtils.propertyOverrideForLocalRef(this);
	}

	/**
	 * Adds the <code>item</code> to the end of the collection and fires a notification to listeners.
	 */
	addLocalRef(item) {
		this.addLocalRefAt(this.getLocalRef().length, item);
	}

	/**
	 * Removes the item at <code>position</code> from the collection and fires a notification to listeners.
	 */
	removeLocalRefAt(position) {
		this._removeAtAndNotify(this.getLocalRef(), position, 73, true);
	}

	/**
	 * Removes the <code>item</code> from the collection and fires a notification to listeners.
	 */
	removeLocalRef(item) {
		var i = this.getLocalRef().indexOf(item);
		if (i >= 0) {
			this.removeLocalRefAt(i);
		}
	}

	/**
	 * Retrieves the type of this object
	 * @return {String} the object type in a <code>String</code>
	 */
	getObjectType() {
		return "ItemHierarchy";
	}

	/**
	 * Get a list of FeatureObjects
	 * @return {Array} A list of FeatureObjects
	 */
	getFeatureList(factory) {
		var featureList = [];
		featureList.push(this.createFeature(true, false, false, 36, "ref", null));
		var clazz;
		if (factory) {
			clazz = factory.createCalculatedMemberType().getClass();
		}
		featureList.push(this.createFeature(true, false, true, 72, "calculatedMember", clazz));
		if (factory) {
			clazz = factory.createLocalRefType().getClass();
		}
		featureList.push(this.createFeature(true, false, true, 73, "localRef", clazz));
		Array.prototype.push.apply(featureList, super.getFeatureList(factory));
		return featureList;
	}

	/**
	 * Set the value of a specific feature.
	 * @param {BaseMoserObject} value the value to set
	 * @param {int} featureID the feature id of the attribute to be set
	 */
	set(featureID, value) {
		switch (featureID) {
		default:
			super.set(featureID, value);
		}
	}

	/**
	 * Set the value of a specific feature.
	 * @param {BaseMoserObject} value the value to set the value to set
	 * @param {int} featureID the feature id of the attribute to be set the feature id of the attribute to be set
	 */
	_setList(featureID, value) {
		switch (featureID) {
		case 72:
			this.calculatedMember = (value);
			break;
		case 36:
			this.ref = (value);
			break;
		case 73:
			this.localRef = (value);
			break;
		default:
			super._setList(featureID, value);
		}
	}

	/**
	 * Get the value of a specific feature.
	 * @param {int} featureID the feature id of the attribute to get
	 */
	get(featureID) {
		switch (featureID) {
		case 72:
			return this.getCalculatedMember();
		case 36:
			return this.getRef();
		case 73:
			return this.getLocalRef();
		default:
			return super.get(featureID);
		}
	}

	/**
	 * Get the value of a specific feature.
	 * @param {int} featureID the feature id of the attribute to get
	 */
	basicGet(featureID) {
		switch (featureID) {
		case 72:
			return this.basicGetCalculatedMember();
		case 36:
			return this.basicGetRef();
		case 73:
			return this.basicGetLocalRef();
		default:
			return super.basicGet(featureID);
		}
	}

	/**
	 * Add the value of a specific feature at a specific position
	 * @param {int} position the array position of the item to be added
	 * @param {BaseMoserObject} value the value to add
	 * @param {int} featureID the feature id of the attribute to be added
	 */
	addAt(featureID, position, value) {
		switch (featureID) {
		case 72:
			this.addCalculatedMemberAt(position, (value));
			break;
		case 36:
			this.addRefAt(position, (value));
			break;
		case 73:
			this.addLocalRefAt(position, (value));
			break;
		default:
			super.addAt(featureID, position, value);
		}
	}

	/**
	 * Add the value to the end of a specific collection feature
	 * @param {BaseMoserObject} value the value to add
	 * @param {int} featureID the feature id of the attribute to be added
	 */
	add(featureID, value) {
		switch (featureID) {
		case 72:
			this.addCalculatedMember((value));
			break;
		case 36:
			this.addRef((value));
			break;
		case 73:
			this.addLocalRef((value));
			break;
		default:
			super.add(featureID, value);
		}
	}

	/**
	 * Remove the value of a specific feature by index.
	 * @param {int} position the array position of the item to be removed
	 * @param {int} featureID the feature id of the attribute to be removed
	 */
	removeAt(featureID, position) {
		switch (featureID) {
		case 72:
			this.removeCalculatedMemberAt(position);
			break;
		case 36:
			this.removeRefAt(position);
			break;
		case 73:
			this.removeLocalRefAt(position);
			break;
		default:
			super.removeAt(featureID, position);
		}
	}

	/**
	 * Remove the value from specific feature.
	 * @param {BaseMoserObject} item the item to be removed
	 * @param {int} featureID the feature id of the attribute to be removed
	 */
	remove(featureID, item) {
		switch (featureID) {
		case 72:
			this.removeCalculatedMember((item));
			break;
		case 36:
			this.removeRef((item));
			break;
		case 73:
			this.removeLocalRef((item));
			break;
		default:
			super.remove(featureID, item);
		}
	}
}


// WEBPACK FOOTER //
// ./src/generated/ItemHierarchy.js